import React from 'react';
import { DataTableBody } from './components/data-table-body/data-table-body';
import { DataTableHead } from './components/data-table-head/data-table-head';
import * as S from './data-table.styles';
// eslint-disable-next-line @typescript-eslint/ban-types
export const DataTable = ({ columns, rows, className, testId, onRowClick, noDataMessage, }) => {
    if (!(columns === null || columns === void 0 ? void 0 : columns.length) || !rows) {
        return null;
    }
    return (React.createElement(S.DataTable, { "data-testid": testId || 'data-table', className: className },
        React.createElement(DataTableHead, { columns: columns }),
        React.createElement(DataTableBody, { columns: columns, onRowClick: onRowClick, noDataMessage: noDataMessage, rows: rows })));
};
//# sourceMappingURL=data-table.js.map